<template>
  <div class="xjydsqDetail">
    <Header
      :title="info.type === 'detail' ? '异动详情' : '异动申请'"
      type="1"
      :route="'/xjydsq/index?active=' + info.active"
    ></Header>
    <div
      class="xjydsqDetail_main"
      :style="info.type === 'apply' ? `height: calc(100% - 78px)` : ''"
    >
      <div
        :class="{
          xsxxxgsq_main_header: true,
          wtg: info.iswfmes == 0,
          ytg: info.iswfmes == 1,
          shz: info.iswfmes == 2,
          dsh: info.iswfmes == 3
        }"
      >
        <div class="header_title">
          <h3>
            {{ xsydxx.xm ? xsydxx.xm : "-" }}-{{ xsydxx.xh ? xsydxx.xh : "-" }}
          </h3>
          <div
            :class="{
              header_icon: true,
              man: xsydxx.xb === '男',
              woman: xsydxx.xb === '女'
            }"
          >
            <svg
              class="svg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 12 12"
            >
              <path
                d="M11.5,0.5 L11.5,5 L10.5,5 L10.5,2.102 L8.00732756,4.59710411 C8.62832483,5.36858865 9,6.34923565 9,7.41669203 C9,9.9019734 6.98528137,11.916692 4.5,11.916692 C2.01471863,11.916692 0,9.9019734 0,7.41669203 C0,4.93141065 2.01471863,2.91669203 4.5,2.91669203 C5.55697954,2.91669203 6.52884536,3.28110718 7.29681175,3.89115179 L9.688,1.5 L7,1.5 L7,0.5 L11.5,0.5 Z M4.5,3.91669203 C2.56700338,3.91669203 1,5.4836954 1,7.41669203 C1,9.34968865 2.56700338,10.916692 4.5,10.916692 C6.43299662,10.916692 8,9.34968865 8,7.41669203 C8,5.4836954 6.43299662,3.91669203 4.5,3.91669203 Z"
                fill="currentColor"
                fill-rule="nonzero"
              ></path>
            </svg>
            <span>{{ xsydxx.xb ? xsydxx.xb : "-" }}</span>
          </div>
        </div>
        <ul v-if="info.type === 'detail'" class="header_info">
          <li>
            <span>异动类别:</span>
            <p>{{ xsydxx.ydlb ? xsydxx.ydlb : "-" }}</p>
          </li>
          <li>
            <span>异动原因:</span>
            <p>{{ xsydxx.ydyy ? xsydxx.ydyy : "-" }}</p>
          </li>
        </ul>
      </div>
      <div class="xjydsqDetail_main_content">
        <van-collapse v-model="activeNames">
          <van-collapse-item name="1">
            <template #title>
              <div class="item_title">学生当前情况</div>
            </template>
            <mode-xsdqqk :info="xsdqqk"></mode-xsdqqk>
          </van-collapse-item>
          <van-collapse-item name="2">
            <template #title>
              <div class="item_title">异动后情况</div>
            </template>
            <mode-ydhqk
              v-if="info.type === 'detail'"
              :info="ydhqk"
            ></mode-ydhqk>
            <mode-ydhqzk-apply
              ref="modeYdhqzkApply"
              v-else
              :info="info"
              :selectDataMap="selectDataMap"
            ></mode-ydhqzk-apply>
          </van-collapse-item>
          <van-collapse-item
            v-if="info.type === 'detail'"
            title="附件"
            name="3"
          >
            <mode-file :fileList="fjList" :type="info.type"></mode-file>
          </van-collapse-item>
        </van-collapse>
        <div v-if="info.type === 'apply'" class="van-collapse-item">
          <mode-file ref="modeFile"></mode-file>
        </div>
      </div>
      <div class="back_top" @click="backTop">
        <van-icon name="back-top" />
      </div>
    </div>
    <div v-if="info.type === 'apply'" class="update-button">
      <van-button type="default" @click="cancel">取消</van-button>
      <van-button type="primary" @click="savData">提交</van-button>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
import modeXsdqqk from "./mode/modeXsdqqk.vue";
import ModeYdhqk from "./mode/modeYdhqk.vue";
import ModeYdhqzkApply from "./mode/modeYdhqzkApply.vue";
import modeFile from "./mode/modeFile.vue";
export default {
  components: { modeXsdqqk, ModeYdhqk, ModeYdhqzkApply, modeFile },
  data() {
    return {
      info: {},
      xsydxx: {},
      xsdqqk: {},
      ydhqk: {},
      fjList: [],
      selectDataMap: {},
      activeNames: ["1", "2", "3"]
    };
  },
  created() {
    this.info = this.$route.query;
    if (this.info.type === "detail") {
      this.getListDetail();
    } else {
      this.getListApply();
    }
  },
  methods: {
    cancel() {
      this.$router.replace("/xjydsq/index?active=" + this.info.active);
    },
    savData() {
      if (this.info.type === "apply") {
        this.$refs.modeYdhqzkApply.savData();
      }
    },
    backTop() {
      $(".xjydsqDetail_main")[0].scrollTop = 0;
    },
    async getListDetail() {
      this.arrList = [];
      const res = await Api.xjydDetail({ xs0702id: this.info.xs0702id });
      if (res.code == "1") {
        this.xsydxx = res.data.xsydxx;
        this.xsdqqk = res.data.xsdqqk;
        this.ydhqk = res.data.ydhqk;
        this.fjList = res.data.fjList;
      }
    },
    async getListApply() {
      this.arrList = [];
      const res = await Api.xjydsqInit();
      if (res.code == "1") {
        this.info.nowtime = res.data.nowtime;
        this.xsydxx = res.data.xsxx;
        this.info.xh = this.xsydxx.xh;
        this.info.ydwhsfqy = res.data.kzData.ydwhsfqy;
        this.xsdqqk = res.data.xsdqqk;
        this.info.xs0101id = this.xsdqqk.xs0101id;
        let defaultXnxqIndex = 0;
        let defaultZyIndex = 0;
        this.selectDataMap = {
          sxxq: [
            {
              values: res.data.selectDataMap.xnxqList.map((item, index) => {
                if (item.isdqxq === "1") {
                  defaultXnxqIndex = index;
                }
                return {
                  text: item.xnxqmc,
                  value: item.xnxq01id
                };
              }),
              defaultIndex: defaultXnxqIndex
            }
          ],
          ydlb: [
            {
              values: res.data.selectDataMap.ydlbList.map(item => {
                return {
                  text: item.ydlbdmmc,
                  value: item.dm
                };
              })
            }
          ],
          byzy: [
            {
              values: res.data.selectDataMap.zyList.map((item, index) => {
                if (item.byzyid === this.xsdqqk.jx01ndid) {
                  defaultZyIndex = index;
                  this.info.zymc = {
                    text: item.zy_mc,
                    value: item.byzyid,
                    defaultIndex: index
                  };
                }
                return {
                  text: item.zy_mc,
                  value: item.byzyid
                };
              }),
              defaultIndex: defaultZyIndex
            }
          ],
          zymc: [
            {
              values: res.data.selectDataMap.zyList.map(item => {
                return {
                  text: item.zy_mc,
                  value: item.byzyid
                };
              }),
              defaultIndex: defaultZyIndex
            }
          ]
        };
      }
    }
  }
};
</script>

<style lang="less" scoped>
.xjydsqDetail {
  height: 100%;
  background-color: #f2f2f4;
  overflow: auto;
  .xjydsqDetail_main {
    overflow: auto;
    .xsxxxgsq_main_header {
      position: relative;
      background-image: linear-gradient(168deg, #ffffff 36%, #f3f2ff 100%);
      border: 1.5px solid #ffffff;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.08);
      border-radius: 0 0 10px 10px;
      padding: 14px 20px;

      .header_title {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        h3 {
          font-family: PingFangSC-Medium;
          font-size: 18px;
          color: #333333;
          letter-spacing: 0;
          font-weight: bolder;
          max-width: calc(~"100% - 43px");
        }
        .header_icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 38px;
          height: 17px;
          border-radius: 9px;
          margin-left: 5px;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          letter-spacing: 0;
          font-weight: 400;
          .svg {
            width: 12px;
            height: 12px;
          }
          span {
            margin-left: 2px;
          }

          &.man {
            background: rgba(1, 137, 249, 0.15);
            color: #0189f9;
          }
          &.woman {
            background: rgba(255, 71, 60, 0.15);
            color: #ff473c;
          }
        }
      }
      .header_info {
        li {
          display: flex;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #666666;
          letter-spacing: 0;
          font-weight: 400;
          span {
            white-space: nowrap;
          }
          p {
            white-space: wrap;
            margin-left: 5px;
          }
          & + li {
            margin-top: 2px;
          }
        }
      }

      &::before {
        content: "";
        position: absolute;
        right: 15px;
        width: 70px;
        height: 70px;
        top: 50%;
        transform: translate(0, -50%);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
      }
      &.wtg {
        background-image: linear-gradient(265deg, #f88f52 0%, #f85352 100%);
        box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.09);
        .header_title h3,
        .header_info li {
          color: #fff;
        }
        .header_icon {
          color: #fff !important;
          background-color: rgba(255, 255, 255, 0.15) !important;
        }
        &::before {
          background-image: url("~@/assets/images/sh_wtg.png");
        }
      }
      &.ytg {
        background-image: linear-gradient(262deg, #41b28d 0%, #41b29c 100%);
        box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.08);
        .header_title h3,
        .header_info li {
          color: #fff;
        }
        .header_icon {
          color: #fff !important;
          background-color: rgba(255, 255, 255, 0.15) !important;
        }
        &::before {
          background-image: url("~@/assets/images/sh_ytg.png");
        }
      }
      &.shz {
        background-image: linear-gradient(265deg, #ffa400 0%, #ef9e0d 100%);
        box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.09);
        .header_title h3,
        .header_info li {
          color: #fff;
        }
        .header_icon {
          color: #fff !important;
          background-color: rgba(255, 255, 255, 0.15) !important;
        }
        &::before {
          background-image: url("~@/assets/images/sh_shz.png");
        }
      }
    }
    .xjydsqDetail_main_content {
      padding: 10px 15px 0;
      height: calc(~"100% - 78px");
      .item_title {
        position: relative;
        padding-left: 12px;
        line-height: 22px;
        &::before {
          content: "";
          position: absolute;
          height: 16px;
          border-left: 4px solid #7469f8;
          border-radius: 2px;
          left: 0;
          top: 3px;
        }
      }
      /deep/.item_main {
        & > li {
          display: flex;
          & + li {
            margin-top: 8px;
          }
          span {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #333333;
            letter-spacing: 0;
            font-weight: 400;
            white-space: nowrap;
            line-height: 20px;
          }
          p {
            white-space: wrap;
            margin-left: 5px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #666666;
            letter-spacing: 0;
            font-weight: 400;
            line-height: 20px;
          }
        }
      }
    }
    /deep/.van-collapse-item {
      background: #ffffff;
      box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      overflow: hidden;
      margin-bottom: 10px;

      .van-cell {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 400;
      }
      .van-cell__right-icon {
        color: #333333;
      }
      .van-collapse-item__title::after {
        right: 0;
        left: 0;
        border-bottom: 1px solid #e5e5e5;
      }
      .van-collapse-item__content {
        padding: 14px 15px;
      }
    }
    .back_top {
      position: fixed;
      display: flex;
      justify-content: center;
      align-items: center;
      right: 8px;
      bottom: 20%;
      width: 40px;
      height: 40px;
      background: #7469f8;
      background-color: #7469f8;
      border-radius: 50%;
      .van-icon {
        color: #fff;
        font-weight: bolder;
        font-size: 25px;
      }
    }
    /deep/.van-cell-group {
      margin-bottom: 8px;
      .van-cell {
        padding: 14px 15px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        letter-spacing: 0;
        font-weight: 400;
        &::after {
          left: 15px;
          right: 15px;
          border-bottom: 1px solid #e5e5e5;
        }
        .van-field__label {
          span {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #333333;
            letter-spacing: 0;
            font-weight: 400;
          }
        }
        .van-field__control::placeholder {
          color: #b2b2b2 !important;
        }
        .van-field__right-icon {
          .van-icon {
            color: #b2b2b2;
          }
        }
        .van-field__word-limit {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #b2b2b2;
          letter-spacing: 0.3px;
          font-weight: 400;
        }
        &.qz-textarea {
          flex-direction: column;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          letter-spacing: 0.3px;
          font-weight: 400;
          .van-field__control::placeholder {
            color: #b2b2b2 !important;
          }
        }
      }
    }
  }
  .update-button {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    left: 0;
    bottom: 0;
    height: 70px;
    background: #ffffff;
    padding: 10px 15px;
    border-top: 1px solid #e5e5e5;
    .van-button {
      height: 100%;
      width: calc(~"50% - 7.5px");
      border: 1px solid #e5e5e5;
      border-radius: 25px !important;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      letter-spacing: 0;
      text-align: center;
      font-weight: 500;
    }
    .van-button--normal {
      color: #666666;
    }
    .van-button--primary {
      color: #ffffff;
      background-color: #7469f8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/xjydsq/detail.vue